import { render, staticRenderFns } from "./cinema-category-tabs.vue?vue&type=template&id=e77ebaf2&"
import script from "./cinema-category-tabs.vue?vue&type=script&lang=ts&"
export * from "./cinema-category-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports